var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back flex",on:{"click":_vm.handleBack}},[_c('van-icon',{attrs:{"name":"arrow-left","color":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }